import { render } from "./OptionSelectorWrapper.vue?vue&type=template&id=541945d4&scoped=true"
const script = {}

import "./OptionSelectorWrapper.vue?vue&type=style&index=0&id=541945d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541945d4"]])

export default __exports__